import { useParams, Redirect, useLocation } from 'react-router-dom';
import { useTicketThread } from '../data/useTicketThread';
import { useTicketThreads } from '../data/useTicketThreads';
import { TicketThreadViewer } from './TicketThreadViewer';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import I18n from 'I18n';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketThreadViewerWrapper({
  setIsInfoPanelOpen,
  isAttachmentsPanelOpen,
  setIsAttachmentsPanelOpen
}) {
  const {
    ticketId,
    threadId
  } = useParams();
  const location = useLocation();
  const isCreatingThread = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('creatingThread') === '1';
  }, [location.search]);
  const {
    threads,
    latestThread,
    loading: threadsLoading,
    error: threadsError
  } = useTicketThreads(Number(ticketId), {
    shouldPoll: isCreatingThread && !threadId
  });
  const ticketThread = useTicketThread(Number(ticketId), threadId || '');
  const handleTryAgain = () => {
    // POLISH: Would like to have different handlers here ideally.
    // If threads fails and we dont have a thread, then we should offer refresh as this does now.
    // But threads succeeds, and we have a thread, then we should offer a refetch of the new thread.
    // Refreshing wipes cache -- if only one of the thread fetches fails, we should not wipe cache and handle
    // that failure more gracefully.

    window.location.reload();
  };
  if (!threadId && latestThread && !threadsLoading) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/ticket/${ticketId}/${latestThread.threadId}`,
        search: ''
      }
    });
  }
  if ((threadsError || ticketThread.error) && !ticketThread.data) {
    return /*#__PURE__*/_jsx(Flex, {
      flex: "1",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "400",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleTryAgain,
        children: I18n.text('customer-portal-app.ticketInfoPanel.tryAgain')
      })
    });
  }
  return /*#__PURE__*/_jsx(TicketThreadViewer, {
    threads: threads,
    isCreatingThread: isCreatingThread,
    setIsInfoPanelOpen: setIsInfoPanelOpen,
    isAttachmentsPanelOpen: isAttachmentsPanelOpen,
    setIsAttachmentsPanelOpen: setIsAttachmentsPanelOpen,
    ticketThread: ticketThread,
    isLoading: threadsLoading || ticketThread.loading
  });
}